import { useState, useEffect } from "react";

export const useDebounce = (value, delay = 1000) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

export const buildQueryParams = (params, excludeValues = ["", "all"]) => {
  const query = {};

  Object.entries(params).forEach(([key, value]) => {
    const isExcluded =
      excludeValues.includes(value) || value === null || value === undefined;
    if (!isExcluded) {
      query[key] = value;
    }
  });

  return query;
};

export const generateLuxuryWatchContent = (data) => {
  const name = data?.name || "";
  const brand = data?.brand?.name || "";
  const model = data?.model?.name || "";

  const d = data?.product_watchdetail || {};

  const year = d.year;
  const gender = d.gender;
  const dial = d?.dial?.name;
  const dialNumeral = d?.dial_numeral?.name;
  const caseMaterial = d?.case?.name;
  const caseSize = d?.case_diameter?.name;
  const band = d?.band_description?.name || d?.band?.name;
  const movement = d?.movement?.name;
  const caliber = d?.caliber?.name;
  const powerReserve = d?.power_reserve;
  const waterResistance = d?.water_resistance;

  const cleanCaliber = caliber?.replace("Cal. ", "");

  // Styled Title
  const title = `${brand} ${model} — ${name}`;

  const lines = [];

  lines.push(
    `${brand} ${model} presents the ${name}, an exquisite ${brand ? `${brand} ` : ""}timepiece.`,
  );

  if (caseSize || caseMaterial || dial) {
    lines.push(
      `Crafted with a ${caseSize ? caseSize + " " : ""}${caseMaterial?.toLowerCase() || ""} case, it reveals a ${dial?.toLowerCase()} dial${dialNumeral ? ` accented by ${dialNumeral.toLowerCase()}` : ""}, embodying timeless elegance and refined character.`,
    );
  }

  if (band) {
    lines.push(
      `The watch is complemented by a ${band.toLowerCase()}, offering a graceful balance of comfort and sophistication.`,
    );
  }

  if (movement || cleanCaliber) {
    lines.push(
      `Powering the piece is a ${movement ? movement + " movement" : "precision movement"}${cleanCaliber ? `, caliber ${cleanCaliber}` : ""}, engineered for reliability and smooth performance.`,
    );
  }

  if (powerReserve || waterResistance) {
    lines.push(
      `Designed for modern lifestyles, it offers a ${powerReserve} power reserve and water resistance up to ${waterResistance}.`,
    );
  }

  if (year || gender) {
    lines.push(
      `Originally introduced in ${year}, this model reflects ${brand}'s dedication to exceptional craftsmanship${gender ? ` and is thoughtfully designed for ${gender.toLowerCase()} collectors` : ""}.`,
    );
  }

  return {
    title,
    description: lines.join(" "),
  };
};

export const capitalizeFirstWord = (text) => {
  if (!text) return "";

  return text?.charAt(0).toUpperCase() + text?.slice(1);
}